import React, { useEffect, useState, useRef } from 'react';
import { areEqual } from '../../util';
import { ServiceErfa } from '../../services/service-erfa';
import { NotificationManager } from 'react-notifications';
import StarRating from '../../components/shared/Rating';
import RateQuestion from './rateQuestion';
import BtDropdown from './../bt-select/bt-select';
import BtButton from '../bt-button/bt-button';
import appState from '../../state/AppStateContainer';
import '../app-chat-mail-batch/app-chat-mail-batch.css';
import '../app-select-industry-types/app-select-industry-types.css';
import './rating-form.css';
import BackButton from '../../components/shared/BackButton/BackButton';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import BtGrid from '../bt-grid/bt-grid';
import File from '../../components/File/File';
import AppLayout from '../../components/layout/app-layout/app-layout';
import { useTranslation } from 'react-i18next';
import ArrowIcon from '../../components/svgs/arrowIcon';
import moment from 'moment';
import 'moment/locale/sv.js';
import 'moment/locale/nb.js';
import 'moment/locale/da.js';

const formatDateTime = (date) => date ? moment(date).locale(appState.state.language ?? 'sv').format('LL LT') : '';

const Ratingform = React.memo(function RatingForm(props) {
  const [reqError, setRequiredError] = useState('');
  const [erfaData, setErfaData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [processForm, setProcessForm] = useState(false);
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [projectsArr, setProjectsArr] = useState([]);
  const [usersArr, setUsersArr] = useState([]);
  const [erfaArr, setErfaArr] = useState([]);
  const [currentProject, setCurrentProject] = useState('');
  const [currentUser, setCurrentUser] = useState('');
  const [mainUserArr, setMainUserArr] = useState([]);
  const [expandedProjects, setExpandedProjects] = useState({});
  const [t] = useTranslation('rating');

  async function fetchData(id) {
    if (!erfaData) {
      const _erfaData = await ServiceErfa.getErfa(id);
      if (_erfaData.error) {
        NotificationManager.error(_erfaData.error.message, t('notification.error', 'Fel'));
        return;
      }
      setErfaData(_erfaData);
      setContentData(_erfaData.other);
      if (_erfaData.isRated) {
        setDisableBtn(true);
      }
    }
  }

  useEffect(() => {
    (async () => {
      let checkPath = window.location.pathname.split('/');
      if (checkPath.pop() !== 'true') {
        setLoader(true);
        const _id = window.location.pathname.split('/').pop();
        await fetchData(_id);
        setLoader(false);
      } else {
        let supplierId = checkPath.pop();
        if (!projectsArr.length) {
          try {
            const data = await ServiceErfa.getErfaForSupplier(supplierId);
            const { projectsArr, userArr, erfaData } = data;
            setMainUserArr(userArr.map(u => (
              {
                ...u,
                label: t('areaRatedBy', '{{area}} utvärderat av {{user}}', { area: u.areaName, user: u.userName })
              }
            )));
            setErfaArr(erfaData);
            setUsersArr(userArr.map(u => (
              {
                ...u,
                label: t('areaRatedBy', '{{area}} utvärderat av {{user}}', { area: u.areaName, user: u.userName })
              }
            )));
            setProjectsArr(projectsArr);
            setDisableBtn(true);
            setCurrentProject(projectsArr[0].value);
            setData(projectsArr[0].value, erfaData);
            setUser(projectsArr[0].value);
            if (erfaData.length > 0) {
              setExpandedProjects({ [erfaData[0].projectId]: true });
            }
          } catch (e) {
            console.log(e, ':::::ERROR:::::');
            NotificationManager.error(e.error);
          }
        }
      }
    })()
  }, [files, newFiles, erfaArr, erfaData, usersArr, currentUser]);

  const userSelect = useRef(null);

  const setData = (project, erfaArr) => {
    const checkErfa = isExists(erfaArr, 'projectId', project);
    if (checkErfa.length) {
      setContentData(checkErfa[0].other);
      setErfaData(checkErfa[0]);
    }
  };

  const setUser = project => {
    let filterUser = mainUserArr?.length ?
      mainUserArr.filter(user => user.projectId == project)
      : [];
    if (filterUser.length) {
      if (userSelect?.current) {
        userSelect.current.labelValue = filterUser[0].label;
        userSelect.current.state.labelValue = filterUser[0].label;
        userSelect.current.value = filterUser[0].value;
      }
      setUsersArr(filterUser);
      setCurrentUser(filterUser[0]?.value);
      onChangeUser(filterUser[0]?.label);
    }
  };

  const isExists = (arr, key, search) => {
    return arr.filter((el) => el[key] === search);
  };

  const setContentData = content => {
    setContent(content ?? '');
  };

  const generateUploadedFiles = item => {
    return (
      <div className="item-overflow" key={item.id}>
        <div className="item">
          <svg
            onClick={uploadItemRemoveClickCallback}
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g fill="none" fillRule="evenodd">
              <path
                fill="red"
                fillRule="nonzero"
                d="M7,0 C10.8593333,0 14,3.14066667 14,7 C14,10.8593333 10.8593333,14 7,14 C3.14066667,14 0,10.8593333 0,7 C0,3.14066667 3.14066667,0 7,0 Z"
              />
              <rect width="8" height="2" x="3" y="6" fill="#FFF" />
            </g>
          </svg>
          <File
            disabled
            key={`filename${item.id}`}
            fileName={item.fileName || item.file}
            file={item.fileName || item.file}
          />
        </div>
      </div>
    );
  };

  const uploadItemRemoveClickCallback = e => {
    if (files && files?.length > 0) {
      var target = e.target;
      var item = target.closest('.item-overflow');
      const index = [...item.parentElement.children].indexOf(item);
      var file = files[index];
      delete newFiles[file.id];
      files.splice(index, 1);
      setFiles([...files]);
      setNewFiles(newFiles);
    }
  };

  const setComment = (e, i) => {
    let cloneErfa = erfaData;
    cloneErfa.questions[i].comment = e;
    setErfaData(cloneErfa);
  };

  const setRating = (e, i) => {
    let cloneErfa = erfaData;
    cloneErfa.questions[i].rating = e;
    setErfaData(cloneErfa);
  };

  const isRatingFilled = () => {
    var index = -1;
    for (var i = 0; i < erfaData.questions.length; i++) {
      if (!erfaData.questions[i].rating) {
        index = i;
        break;
      }
    }
    return index;
  };

  const submitRatings = async () => {
    if(disableBtn) return;
    const checkRating = isRatingFilled();
    if (checkRating !== -1) {
      setRequiredError(t('validation.required', 'Vänligen betygsätt alla frågor'));
      setTimeout(() => setRequiredError(''), 2000);
      return;
    }
    setProcessForm(true);
    let dataToSend = {
      files: files,
      other: content,
      erfaData,
      token: window.location.pathname.split('/').pop(),
    };
    let result;
    try {
      result = await ServiceErfa.submitRating(dataToSend);
    } catch (e) {
      setProcessForm(false);
      const message = e?.response?.data?.error;
      if (message) NotificationManager.error(message, t('notification.error', 'Fel'));
      return;
    }
    
    const updatedErfaData = {
      ...erfaData,
      isRated: true,
      updatedAt: new Date().toISOString(),
      questions: erfaData.questions,
      other: content
    };
    setErfaData(updatedErfaData);
    
    const updatedErfaArr = erfaArr.map(erfa => 
      erfa._id === erfaData._id ? updatedErfaData : erfa
    );
    setErfaArr(updatedErfaArr);
    
    setDisableBtn(true);
    setProcessForm(false);
    NotificationManager.success(result.message);
  };

  const onChangeProject = (value, type) => {
    setUser(value);
    setCurrentProject(value);
    setData(value, erfaArr);
  };

  const onChangeUser = (value, type) => {
    setCurrentUser(value);
    let filteredErfa = erfaArr.find(el => {
      return el.userEmail + '-' + el.areaName == value && el.projectId == currentProject;
    });
    if (filteredErfa) {
      setContentData(filteredErfa.other);
      setErfaData(filteredErfa);
    }
  };

  const groupEvaluationsByProject = () => {
    const grouped = {};
    erfaArr.forEach(erfa => {
      if (!grouped[erfa.projectId]) {
        grouped[erfa.projectId] = {
          projectId: erfa.projectId,
          projectName: erfa.projectName,
          projectNumber: erfa.projectNumber,
          evaluations: []
        };
      }
      grouped[erfa.projectId].evaluations.push(erfa);
    });
    return Object.values(grouped);
  };

  const toggleProject = (projectId) => {
    setExpandedProjects(prev => ({
      ...prev,
      [projectId]: !prev[projectId]
    }));
  };

  const renderEvaluationItem = (erfa, index) => {
    const isActive = erfaData?._id === erfa._id;
    return (
      <div
        key={erfa._id || index}
        className={`evaluation-item ${isActive ? 'active' : ''}`}
        onClick={() => {
          setErfaData(erfa);
          setContentData(erfa.other);
          if (erfa.isRated) {
            setDisableBtn(true);
          } else {
            setDisableBtn(false);
          }
        }}
        style={{
          padding: '12px 16px 12px 32px',
          
          cursor: 'pointer',
          backgroundColor: isActive ? '#f3f4f6' : 'transparent',
          transition: 'background-color 0.2s'
        }}
        onMouseEnter={(e) => !isActive && (e.currentTarget.style.backgroundColor = '#f9fafb')}
        onMouseLeave={(e) => !isActive && (e.currentTarget.style.backgroundColor = 'transparent')}
      >
        <div style={{ fontSize: '13px', color: 'var(--gray-700)', marginBottom: '2px', fontWeight: isActive ? 600 : 400 }}>
          {erfa.areaName}
        </div>
        <div style={{ fontSize: '13px', color: 'var(--gray-700)', marginBottom: '4px' }}>
          {erfa.userName}
        </div>
        {erfa.updatedAt && (
          <div style={{ fontSize: '12px', color: '#9ca3af' }}>
            {new Date(erfa.updatedAt).toLocaleString('sv-SE', { 
              year: 'numeric', 
              month: '2-digit', 
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </div>
        )}
      </div>
    );
  };

  const renderProjectGroup = (projectGroup) => {
    const isExpanded = expandedProjects[projectGroup.projectId];
    const hasActiveEvaluation = projectGroup.evaluations.some(erfa => erfaData?._id === erfa._id);
    
    return (
      <div key={projectGroup.projectId}>
        <div
          onClick={() => toggleProject(projectGroup.projectId)}
          style={{
            padding: '12px 16px',
            cursor: 'pointer',
            backgroundColor: hasActiveEvaluation ? '#f3f4f6' : 'transparent',
            transition: 'background-color 0.2s'
          }}
          onMouseEnter={(e) => !hasActiveEvaluation && (e.currentTarget.style.backgroundColor = '#f9fafb')}
          onMouseLeave={(e) => !hasActiveEvaluation && (e.currentTarget.style.backgroundColor = 'transparent')}
        >
          <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
            <ArrowIcon className={`sp-db-arrow-icon ${isExpanded ? 'sp-db-arrow-icon--down' : ''}`} />
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: '14px', color: 'var(--gray-700)', marginBottom: '4px' }}>
                {projectGroup.projectName}
              </div>
              <div style={{ fontSize: '12px', color: '#9ca3af' }}>
                {projectGroup.evaluations.length} {projectGroup.evaluations.length === 1 ? t('sidebar.evaluation', 'utvärdering') : t('sidebar.evaluations', 'utvärderingar')}
              </div>
            </div>
          </div>
        </div>
        {isExpanded && projectGroup.evaluations.map((erfa, index) => renderEvaluationItem(erfa, index))}
      </div>
    );
  };

  function renderContent() {
    const { supplierName, projectName, projectNumber } = erfaData;
  
    return (
      <div style={{ display: "flex", padding: "32px", position:'relative' }}>
        <div style={{ display: "flex", gap: "32px", width: "100%", justifyContent: "flex-start" }}>
  
          <div className="rating-form-card-container" style={{ display: "flex", width: "700px", flexShrink: 0 }}>
            <div className="rating-form-card status-idle hydrated" style={{ paddingBottom: "32px", flex: 1 }}>
  
              <BtRow className="header card-header">
                <BtColumn>
                  <h1>{supplierName}</h1>
                  <h2>{t("pageTitle", "Erfarenhetsåterföringsformulär")}</h2>
                </BtColumn>
              </BtRow>
  
              <div className="container--quo" style={{ marginTop: "24px" }}>
                <BtRow>
                  <BtColumn>
                    <div className="card-information">
                      <span className="headline-label">{t("label.projectName", "Projektnamn")}</span>
                      <span className="headline-info">{projectName}</span>
                    </div>
                  </BtColumn>
  
                  <BtColumn>
                    <div className="card-information">
                      <span className="headline-label">{t("label.projectNo", "Projektnummer")}</span>
                      <span className="headline-info">{projectNumber}</span>
                    </div>
                  </BtColumn>
                </BtRow>
              </div>
  
              <div className="fm-group" style={{ marginTop: "24px" }}>
                <div className="erfaRating">
                  <div className="rating-div">
                    <StarRating
                      rating={1}
                      numberOfStars={1}
                      emptySymbol="fa fa-star-o fa-2x medium"
                      fullSymbol="fa fa-star fa-2x medium"
                      readOnly
                      noNumber
                    />
                    <span className="minStarLabel">{t("label.minStar", "Mycket dåligt")}</span>
  
                    <span className="maxStarLabel">{t("label.maxStar", "Mycket bra")}</span>
  
                    <StarRating
                      rating={5}
                      numberOfStars={5}
                      emptySymbol="fa fa-star-o fa-2x medium"
                      fullSymbol="fa fa-star fa-2x medium"
                      readOnly
                      noNumber
                    />
                  </div>
                </div>
  
                <div className="upload-files-wrapper uploaded-files">
                  {files && files.map((item) => generateUploadedFiles(item))}
                </div>
              </div>
  
              {erfaData?.questions &&
                erfaData.questions.map((question, i) => (
                  <RateQuestion
                    isDisabled={disableBtn}
                    key={question._id}
                    scrollId={i}
                    question={question.question}
                    comment={question.comment || ""}
                    rating={question.rating || 0}
                    setComment={(value) => setComment(value, i)}
                    onRating={(value) => setRating(value, i)}
                  />
                ))}
  
              <label>{t("label.other", "Övrigt")}</label>
              <div className="message-wrapper">
                <textarea
                  className="rating-input"
                  value={content}
                  disabled={disableBtn}
                  onChange={(e) => setContent(e.target.value)}
                />
              </div>
  
              <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "center", marginTop: "24px", clear: "both" }}>
                {reqError && (
                  <span className="error show" style={{ color: "red", paddingRight: 12 }}>
                    {reqError}
                  </span>
                )}
  
                {!reqError && erfaData?.isRated && erfaData?.updatedAt && (
                  <span style={{ paddingRight: 12, color: "#666" }}>
                    {t("label.submittedAt", "Inlämnad den {{date}}", {
                      date: formatDateTime(erfaData.updatedAt),
                    })}
                  </span>
                )}
  
                {!disableBtn && <BtButton
                  class={`btn-send hydrated ${processForm ? "loader-show" : ""}`}
                  loaderShow={processForm}
                  onClick={submitRatings}
                  disabled={disableBtn}
                  id="btn"
                  rightIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="32"
                      viewBox="0 0 33 32"
                    >
                      <path
                        d="M32.5806839,14.6066047 L1.00578206,0.0575495956 C0.981383271,0.0459103516 0.95554926,0.0459103516 0.929715249,0.038635824 C0.888093788,0.0240867689 0.846472326,0.0109926194 0.803415642,0.00517299736 C0.760358958,-0.00064662467 0.720172719,-0.00064662467 0.677116034,0.000808280837 C0.638365018,0.00371809185 0.601049225,0.00662790286 0.562298209,0.0153573359 C0.519241525,0.0240867689 0.480490509,0.0371809185 0.441739493,0.0531848791 C0.418775928,0.0633692176 0.39437714,0.0648241231 0.371413575,0.0764633672 C0.354190902,0.0851928002 0.344144342,0.0997418553 0.328356891,0.109926194 C0.296781989,0.130294871 0.269512756,0.153573359 0.242243522,0.178306753 C0.203492506,0.213224485 0.169047159,0.248142217 0.13890748,0.288879571 C0.130296143,0.300518815 0.117379138,0.307793343 0.108767801,0.320887492 C0.098721241,0.335436547 0.0972860182,0.352895414 0.0886746813,0.368899374 C0.0642758935,0.414001445 0.0441827741,0.460558421 0.029830546,0.511480114 C0.0183487635,0.54494294 0.0111726494,0.578405767 0.00686698098,0.613323499 C0.00112608973,0.656970664 -0.0017443559,0.70061783 0.00112608973,0.7457199 C0.00256131254,0.78791216 0.00686698098,0.83010442 0.0154783179,0.870841774 C0.0183487635,0.889755546 0.0154783179,0.908669317 0.0212192091,0.927583089 L8.63255608,30.0256932 C8.69570589,30.2395643 8.85070995,30.4126981 9.05594681,30.4941728 C9.14206018,30.5276356 9.231044,30.5450945 9.32002781,30.5450945 C9.44632742,30.5450945 9.5711918,30.5116317 9.68170396,30.4461609 L16.9137917,26.1570995 L23.195762,31.8166819 C23.2316425,31.8486898 23.2746992,31.8646938 23.3134502,31.8894272 C23.3450251,31.908341 23.3722944,31.9316194 23.4067397,31.9461685 C23.4914179,31.9810862 23.5804017,32 23.6722559,32 C23.7612398,32 23.8487883,31.9796313 23.9334665,31.9461685 C23.9406426,31.9432587 23.9492539,31.9418038 23.9564301,31.938894 C23.975088,31.9301645 23.9894402,31.9141606 24.0066629,31.9039762 C24.0109685,31.9025213 24.013839,31.8996115 24.0167094,31.8967017 C24.0554604,31.8748781 24.0970819,31.8603291 24.1329625,31.8297761 C24.143009,31.8210466 24.1473147,31.8094074 24.155926,31.8006779 C24.168843,31.7890387 24.1803248,31.7788544 24.1918066,31.7657602 C24.1961123,31.7599406 24.2032884,31.7584857 24.2090293,31.7526661 C24.2233815,31.7366621 24.2276872,31.7148385 24.2406042,31.6973797 C24.2678734,31.6595521 24.2937074,31.6231795 24.3138005,31.5824421 C24.3224119,31.5635283 24.3310232,31.5475244 24.3381993,31.5286106 C24.3468107,31.5038772 24.3525516,31.4791438 24.3582924,31.4544104 C24.3697742,31.4078535 24.3769503,31.3627514 24.3798208,31.3147395 C24.381256,31.2987355 24.3884321,31.2856414 24.3884321,31.2696374 L24.3884321,22.176478 L32.7127244,15.8476391 C32.9150908,15.6934191 33.0241678,15.4431753 32.9954633,15.187112 C32.9696293,14.9354133 32.8103196,14.7128128 32.5806839,14.6066047 Z M9.3981305,29 L2,4 L18,23.8975386 L9.3981305,29 Z M18,25.5557963 L18.6914894,25 L20,28 L18,25.5557963 Z M22.9985353,29 L20.0091542,24.0280465 C19.9827902,23.9286659 19.9359209,23.8336697 19.870011,23.7532883 L7,8 L23,22.4686478 L23,29 L22.9985353,29 Z M23.9090909,21 L5,3 L31,15.4130219 L23.9090909,21 Z"
                        transform="matrix(-1 0 0 1 33 0)"
                      ></path>
                    </svg>
                  }
                >
                  {t("button.send", "Skicka")}
                </BtButton>}
              </div>
            </div>
          </div>

          {erfaArr && erfaArr.length > 0 && (
            <div className="card-base" style={{ width: "320px", overflowY: "auto", flexShrink: 0, display: "flex", flexDirection: "column" }}>
              <div style={{ padding: "32px 32px 20px 32px", backgroundColor: "var(--white)", borderRadius: "6px 6px 0 0" }}>
                <h1 style={{ fontSize: "20px", fontWeight: 400, color: "var(--gray-700)", margin: 0 }}>{t("sidebar.evaluations", "Utvärderingar")}</h1>
              </div>

              {groupEvaluationsByProject().map((projectGroup) => renderProjectGroup(projectGroup))}
            </div>
          )}
        </div>
      </div>
    );
  }
  
  

  const page = (
    <div className="general--page--content page--quotation" style={{ height: '100vh', padding: 0 }}>
      {erfaData && renderContent()}
    </div>
  );

  if (appState.isCustomerUser() && usersArr?.length > 0) {
    return (
      <AppLayout title={<BackButton
        style={{ alignSelf: 'center', margin: '0 20px' }}
        onClick={() => window.history.back()}
        path={[t('pageTitle', 'Erfarenhetsåterföringsformulär')]}
      />}>
        {page}
      </AppLayout>
    );
  } else {
    return page;
  }
}, areEqual);

export default Ratingform;
